import environment from "./base";
const baseApi = "https://edify-api-prod.edify.la";
const authApi = "https://edify-api-prod.edify.la";

const env = environment(baseApi, authApi);
const productionConfig = {
  ...env,
  intervals: {
    ...env.intervals,
    logout: 3600, // 1 hour in seconds
  },
  appUrl: 'https://app.edify.la',
  marketplace: {
    url: 'https://market.edify.la',
  },
  isProduction: true,
  isDevelopment: false,
  env: "production",
  SENTRY_DSN:
    "https://d575f30ee6453e7391f4a6324db5b891@o4510264577818624.ingest.us.sentry.io/4510264581881856",
  googleMaps: {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  },
  googleOAuth: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  },
  mercadoPago: {
    publicKey: "APP_USR-c4c98f5a-e0ae-4f85-bf12-61e264846b7f",
    clientId: "8639587373625884", 
    redirectUri: "https://app.edify.la/documentacion-de-obra/oauth-callback",
  },
  firebase: {
    measurementId: "G-XQMBGFQNSB",
  },
  turnstile: {
    siteKey: "0x4AAAAAACbPi-FmiZpUmDn8",
  },
};

export default productionConfig;
